(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-banner"] && !Shopify.designMode) return;
  try {
    
  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      
    }
  connectedCallback() {
    const sectionId = this.getAttribute('section-id');
    const image = this.querySelector('img');
    const aosAnimation = this.getAttribute('data-aos');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this.parallaxEffect);
        } else {
          window.removeEventListener('scroll', this.parallaxEffect);
        }
      });
    });

    const section = document.getElementById(sectionId);
    observer.observe(section);

    const imageContainer = this;
    imageContainer.style.transform = 'translateY(0)';

    this.parallaxEffect = () => {
      const scrollPosition = window.pageYOffset;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const parallaxValue = (scrollPosition / maxScroll) * 50;
      image.style.transform = `translateY(-${parallaxValue}%) scale(1.2)`;
    };

  }
}

customElements.define('parallax-image', ParallaxImage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
  class productPairs extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url).
      then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error! Status: ".concat(response.status));
        }
        return response.text();
      }).
      then((response) => {
        var frag = document.createDocumentFragment(),
          fetchedContent = document.createElement('div');
        frag.appendChild(fetchedContent);
        fetchedContent.innerHTML = response;

        var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
        if (replacementContent) {
          this.innerHTML = replacementContent.innerHTML;
        }
      });
    }
  }

  customElements.define('product-pairs', productPairs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
 
class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
              const swiperContainer = this.querySelector('.swiper-container');
              const getID = swiperContainer.getAttribute("data-id");
              const swiperID = this.querySelector(`.swipercol-${getID}`);
              const spaceBetween = parseInt(swiperContainer.getAttribute('data-space-between'), 10);
              const perviewDesktop = swiperContainer.getAttribute('data-perview-desktop');
              if (swiperContainer) {
                new Swiper(swiperContainer, {
                  slidesPerView: "auto",
                  freeMode: false,
                  autoHeight: true,
                  calculateHeight:true,
                  freeModeSticky: true,
                  centeredSlides: false,
                  grabCursor: true,
                  watchSlidesVisibility: true,
                  watchSlidesProgress: true,
                  preloadImages: true,
                  updateOnImagesReady: true,
                  spaceBetween: spaceBetween,
                  observer: true,
                  observeParents: true,
                  parallax:true,
                  a11y: true,
                  keyboard: {
                    enabled: true,
                  },
                  breakpoints: {
                    320: {
                      slidesPerView: 2,
                      spaceBetween: 20
                    },
                    576: {
                      slidesPerView: 2,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    992: {
                      slidesPerView: perviewDesktop,
                    }
                  },
                  scrollbar: {
                    el: this.querySelector(".swiper-scrollbar"),
                  },
                  navigation: {
                    nextEl: this.querySelector(".swiper-button-next"),
                    prevEl: this.querySelector(".swiper-button-prev"),
                  },
                });
              } else {
                console.error('No element with class "swiper-container" found.');
              }
            }
            if(typeof jdgm !== 'undefined'){
              jdgm.customizeBadges();
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
class productPairsRight extends HTMLElement {
  connectedCallback() {
    fetch(this.dataset.url).
    then((response) => {
      if (!response.ok) {
        throw new Error("HTTP error! Status: ".concat(response.status));
      }
      return response.text();
    }).
    then((response) => {
      var frag = document.createDocumentFragment(),
        fetchedContent = document.createElement('div');
      frag.appendChild(fetchedContent);
      fetchedContent.innerHTML = response;

      var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
      if (replacementContent) {
        this.innerHTML = replacementContent.innerHTML;
      }
    });
  }
}

customElements.define('product-pairsright', productPairsRight);

class BuyNow extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  connectedCallback() {
    this.checkAgreement();
  }

  handleClick(event) {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    const checkoutButton = this.querySelector('.product-form__buynow');
    
    if (event.target === agreeCheckbox || event.target === this.querySelector('.checkbox__label')) {
      if (agreeCheckbox.checked) {
        checkoutButton.classList.remove('disabled');
      } else {
        checkoutButton.classList.add('disabled');
      }
    }
  }
  checkAgreement() {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    return agreeCheckbox.checked;
  }
}

customElements.define('buy-now', BuyNow);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz-find-your-scent"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  const root = document.getElementById('ff-quiz');
  if (!root) return;

  // ----- Product index -----
  let products = [];
  try {
    products = JSON.parse(document.getElementById('ff-quiz-products').textContent.trim());
  } catch (e) {
    console.error('FF quiz: failed to parse product index', e);
  }

  // Lazy-load remaining product pages from the scent-data endpoint so the quiz
  // can score against the full catalogue (Liquid paginates at 250/page).
  function lazyLoadRemainingPages() {
    fetch('/pages/scent-data', { headers: { 'Accept': 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (!data || typeof data.total_pages !== 'number' || data.total_pages <= 1) return;
        const seen = new Set(products.map((p) => p.id));
        const tasks = [];
        for (let pg = 2; pg <= data.total_pages; pg++) {
          tasks.push(fetch('/pages/scent-data?page=' + pg, { headers: { 'Accept': 'application/json' } })
            .then((r) => (r.ok ? r.json() : null))
            .then((d) => {
              if (!d || !Array.isArray(d.products)) return;
              d.products.forEach((p) => {
                if (!seen.has(p.id)) { seen.add(p.id); products.push(p); }
              });
            })
            .catch(() => {}));
        }
        return Promise.all(tasks);
      })
      .catch(() => {});
  }
  // Start the lazy fetch immediately so additional products are merged before the
  // user finishes the quiz. They'll show up if they've loaded by the time we score.
  if ('requestIdleCallback' in window) {
    requestIdleCallback(lazyLoadRemainingPages, { timeout: 2000 });
  } else {
    setTimeout(lazyLoadRemainingPages, 100);
  }

  // ----- Question definitions -----
  const QUESTIONS = [
    {
      id: 'gender_and_vibe',
      eyebrow: 'Question 1 of 4',
      title: 'Tell us about you',
      helper: '',
      type: 'composite',
      groups: [
        {
          id: 'gender',
          label: 'Who are we composing for?',
          cols: 3,
          options: [
            { value: 'men',     label: 'Him',     emoji: '🧔' },
            { value: 'women',   label: 'Her',     emoji: '🌸' },
            { value: 'unisex',  label: 'Unisex',  emoji: '🤝' }
          ]
        },
        {
          id: 'vibe',
          label: 'What vibe do you wear?',
          cols: 2,
          options: [
            { value: 'quiet',  label: 'Quiet & magnetic',  blurb: 'Skin-close. People lean in.' },
            { value: 'bold',   label: 'Bold & loud',       blurb: 'Walks in before you do.' },
            { value: 'warm',   label: 'Warm & cozy',       blurb: 'A scarf-and-fireplace feeling.' },
            { value: 'fresh',  label: 'Fresh & clean',     blurb: 'Showered. Pressed shirt. Ready.' }
          ]
        }
      ]
    },
    {
      id: 'love_notes',
      eyebrow: 'Question 2 of 4',
      title: 'Notes you love',
      helper: 'Pick all that speak to you.',
      type: 'multi',
      cols: 3,
      options: [
        { value: 'Rose',       label: 'Rose',        emoji: '🌹' },
        { value: 'Oud',        label: 'Oud / Oudh',  emoji: '🪵' },
        { value: 'Vanilla',    label: 'Vanilla',     emoji: '🍦' },
        { value: 'Sandalwood', label: 'Sandalwood',  emoji: '🌳' },
        { value: 'Saffron',    label: 'Saffron',     emoji: '🌾' },
        { value: 'Musk',       label: 'Musk',        emoji: '🤍' },
        { value: 'Jasmine',    label: 'Jasmine',     emoji: '🌼' },
        { value: 'Citrus',     label: 'Citrus',      emoji: '🍋' },
        { value: 'Spice',      label: 'Warm spice',  emoji: '🌶️' }
      ]
    },
    {
      id: 'hate_notes',
      eyebrow: 'Question 3 of 4  ·  optional',
      title: 'Anything to avoid?',
      helper: '',
      mode: 'hate',
      type: 'multi',
      cols: 3,
      options: [
        { value: 'Rose',       label: 'Rose',        emoji: '🌹' },
        { value: 'Oud',        label: 'Oud / Oudh',  emoji: '🪵' },
        { value: 'Vanilla',    label: 'Vanilla',     emoji: '🍦' },
        { value: 'Sandalwood', label: 'Sandalwood',  emoji: '🌳' },
        { value: 'Saffron',    label: 'Saffron',     emoji: '🌾' },
        { value: 'Musk',       label: 'Musk',        emoji: '🤍' },
        { value: 'Jasmine',    label: 'Jasmine',     emoji: '🌼' },
        { value: 'Citrus',     label: 'Citrus',      emoji: '🍋' },
        { value: 'Spice',      label: 'Warm spice',  emoji: '🌶️' }
      ],
      skippable: true
    },
    {
      id: 'heritage',
      eyebrow: 'Question 4 of 4',
      title: 'Heritage or designer?',
      helper: 'Pick the path that resonates.',
      type: 'single',
      cols: 1,
      options: [
        { value: 'original',  label: 'Pure Indian original',  emoji: '🪷', blurb: 'Hand-blended Flora Five compositions — saffron, oud, mitti, kewda. Built from the ground up, not borrowed.' },
        { value: 'inspired',  label: 'Inspired by a designer', emoji: '✨', blurb: 'Iconic accords reinterpreted alcohol-free. Baccarat, Bleu, Tom Ford — the silhouette, without the price tag.' },
        { value: 'both',      label: 'Both welcome',          emoji: '🌗', blurb: 'Show me the best of both worlds — heritage and house, side by side.' }
      ]
    }
  ];

  // Mapping from quiz "love_notes" / "hate_notes" picks to canonical note tokens in the index.
  const NOTE_GROUPS = {
    Rose:       ['Rose'],
    Oud:        ['Oud', 'Agarwood'],
    Vanilla:    ['Vanilla', 'Vanilla Bean'],
    Sandalwood: ['Sandalwood', 'Santal'],
    Saffron:    ['Saffron'],
    Musk:       ['Musk', 'White Musk'],
    Jasmine:    ['Jasmine', 'Jasmin'],
    Citrus:     ['Bergamot', 'Lemon', 'Lime', 'Orange', 'Mandarin', 'Grapefruit', 'Citruses'],
    Spice:      ['Pink Pepper', 'Black Pepper', 'Pepper', 'Cardamom', 'Cinnamon', 'Clove', 'Nutmeg', 'Ginger']
  };

  // VIBE → family + intensity
  const VIBE_MAP = {
    quiet: { families: ['Woody', 'Floral', 'Musk'],            intensity: 'Subtle'   },
    bold:  { families: ['Oriental', 'Leather', 'Spicy'],       intensity: 'Loud'     },
    warm:  { families: ['Oriental', 'Gourmand', 'Amber'],      intensity: 'Balanced' },
    fresh: { families: ['Citrus', 'Aquatic', 'Aromatic', 'Fresh'], intensity: 'Subtle' }
  };

  // ----- State -----
  // v2 = also persists `screen` so a refresh keeps users on results/email/questions.
  const STORAGE_KEY = 'ff_quiz_state_v2';
  const STATE_TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days
  const state = loadState() || { current: 0, answers: {}, screen: 'intro' };

  // ----- Render & flow -----
  const screens = {
    intro:     root.querySelector('[data-screen="intro"]'),
    questions: root.querySelector('[data-screen="questions"]'),
    email:     root.querySelector('[data-screen="email"]'),
    loading:   root.querySelector('[data-screen="loading"]'),
    results:   root.querySelector('[data-screen="results"]')
  };
  const questionEl = root.querySelector('[data-question]');
  const progressFill = root.querySelector('[data-progress-fill]');
  const progressLabel = root.querySelector('[data-progress-label]');
  const backBtn = root.querySelector('[data-action="back"]');
  const nextBtn = root.querySelector('[data-action="next"]');

  function show(screen) {
    Object.entries(screens).forEach(([k, el]) => { el.hidden = (k !== screen); });
    state.screen = screen;
    saveState();
    if (screen === 'questions') renderQuestion();
    if (screen !== 'intro') {
      try { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (_) {}
    }
  }

  function saveState() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        v: 2,
        current: state.current,
        answers: state.answers,
        screen: state.screen,
        flora100Granted: !!state.flora100Granted,
        flora100Code: state.flora100Code || null,
        email: state.email || null,
        ts: Date.now()
      }));
    } catch (_) {}
  }
  function loadState() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const d = JSON.parse(raw);
      if (d.ts && Date.now() - d.ts > STATE_TTL_MS) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      if (typeof d.current === 'number' && d.answers) {
        return {
          current: d.current,
          answers: d.answers,
          screen: d.screen || 'intro',
          flora100Granted: !!d.flora100Granted,
          flora100Code: d.flora100Code || null,
          email: d.email || null
        };
      }
    } catch (_) {}
    return null;
  }
  function clearState() {
    try {
      localStorage.removeItem(STORAGE_KEY);
      // Also nuke the legacy v1 key in case it's still around.
      localStorage.removeItem('ff_quiz_state_v1');
    } catch (_) {}
  }

  function renderOptionsHtml(options, type, answer, cols, lockedSet) {
    const isVertical = (cols === 1);
    return options.map((opt, i) => {
      const selected = type === 'multi'
        ? Array.isArray(answer) && answer.includes(opt.value)
        : answer === opt.value;
      const locked = lockedSet && lockedSet.has(opt.value);
      const cls = ['ff-quiz__option'];
      if (selected) cls.push('ff-quiz__option--selected');
      if (locked) cls.push('ff-quiz__option--locked');
      const inner = isVertical
        ? `${opt.emoji ? `<span class="ff-quiz__option-emoji">${opt.emoji}</span>` : ''}
           <span class="ff-quiz__option-content">
             <span class="ff-quiz__option-label">${escapeHtml(opt.label)}</span>
             ${opt.blurb ? `<span class="ff-quiz__option-blurb">${escapeHtml(opt.blurb)}</span>` : ''}
           </span>`
        : `${opt.emoji ? `<span class="ff-quiz__option-emoji">${opt.emoji}</span>` : ''}
           <span class="ff-quiz__option-label">${escapeHtml(opt.label)}</span>
           ${opt.blurb ? `<span class="ff-quiz__option-blurb">${escapeHtml(opt.blurb)}</span>` : ''}`;
      return `<button type="button" class="${cls.join(' ')}"
        data-opt="${opt.value}" data-idx="${i}"
        aria-pressed="${selected ? 'true' : 'false'}"
        ${locked ? 'aria-disabled="true" data-locked="1" tabindex="-1"' : ''}>
        ${inner}
        ${locked ? '<span class="ff-quiz__option-locked-badge" aria-label="You marked this as loved earlier">♥ Loved</span>' : ''}
      </button>`;
    }).join('');
  }

  function renderQuestion() {
    const q = QUESTIONS[state.current];

    // On the hate-notes screen, lock options the user already marked as loved.
    const lockedSet = q.id === 'hate_notes' && Array.isArray(state.answers.love_notes)
      ? new Set(state.answers.love_notes)
      : null;

    const modeClass = q.mode ? ` ff-quiz__question--${q.mode}` : '';
    const modeBanner = q.mode === 'hate'
      ? `<div class="ff-quiz__mode-banner ff-quiz__mode-banner--hate">
           <span class="ff-quiz__mode-banner-icon" aria-hidden="true">⊘</span>
           <div class="ff-quiz__mode-banner-text">
             <strong>Flip side.</strong> Tap any note you'd rather not smell. Skip if none.
           </div>
         </div>`
      : '';

    let body = '';
    if (q.type === 'composite') {
      // Render each sub-group with its own label + options grid.
      body = q.groups.map((g) => {
        const groupAnswer = state.answers[g.id];
        const opts = renderOptionsHtml(g.options, 'single', groupAnswer, g.cols, null);
        return `
          <div class="ff-quiz__sub" data-group="${g.id}">
            <p class="ff-quiz__sub-label">${escapeHtml(g.label)}</p>
            <div class="ff-quiz__options" data-cols="${g.cols || 3}" data-group-id="${g.id}" role="radiogroup">${opts}</div>
          </div>`;
      }).join('');
    } else {
      const answer = state.answers[q.id];
      const optsHtml = renderOptionsHtml(q.options, q.type, answer, q.cols, lockedSet);
      body = `<div class="ff-quiz__options${q.mode === 'hate' ? ' ff-quiz__options--hate' : ''}" data-cols="${q.cols || 3}" role="${q.type === 'multi' ? 'group' : 'radiogroup'}">${optsHtml}</div>`;
    }

    questionEl.className = 'ff-quiz__question' + modeClass;
    questionEl.innerHTML = `
      ${modeBanner}
      <h2 class="ff-quiz__q-title">${escapeHtml(q.title)}</h2>
      ${q.helper ? `<p class="ff-quiz__q-helper">${escapeHtml(q.helper)}</p>` : ''}
      ${body}
    `;

    progressFill.style.width = `${((state.current) / QUESTIONS.length) * 100}%`;
    progressLabel.textContent = q.eyebrow;
    backBtn.hidden = state.current === 0;

    // Continue/skip button visibility:
    //  - composite: show, but only enable when ALL group answers are present
    //  - single (radio): hidden — auto-advance on click
    //  - multi (checkbox): always visible (unless skippable & nothing picked → "Skip")
    if (q.type === 'composite') {
      const allAnswered = q.groups.every((g) => state.answers[g.id]);
      nextBtn.hidden = false;
      nextBtn.disabled = !allAnswered;
      nextBtn.textContent = allAnswered ? 'Continue →' : 'Pick both →';
    } else {
      nextBtn.disabled = false;
      nextBtn.hidden = q.type === 'single' && !q.skippable;
      const a = state.answers[q.id];
      nextBtn.textContent = q.skippable && (!a || (Array.isArray(a) && a.length === 0))
        ? 'Skip →' : 'Continue →';
    }

    questionEl.querySelectorAll('.ff-quiz__option').forEach((btn) => {
      btn.addEventListener('click', () => onOptionClick(btn, q));
    });
  }

  function onOptionClick(btn, q) {
    // Locked options (e.g. notes already marked "loved" on Q4) cannot be picked
    // on Q5. Brief shake animation as a tactile cue.
    if (btn.dataset.locked === '1') {
      btn.classList.remove('ff-quiz__option--shake');
      void btn.offsetWidth; // restart animation
      btn.classList.add('ff-quiz__option--shake');
      return;
    }
    const value = btn.dataset.opt;

    // Composite question (e.g. Q1 = gender + vibe stacked): the answer is stored
    // under the sub-group's id, not the question id. We also stay on this screen
    // until both sub-groups are answered, then enable Continue manually.
    if (q.type === 'composite') {
      const groupContainer = btn.closest('[data-group-id]');
      if (!groupContainer) return;
      const groupId = groupContainer.dataset.groupId;
      state.answers[groupId] = value;
      saveState();
      // Visually mark only the buttons within this sub-group
      groupContainer.querySelectorAll('.ff-quiz__option').forEach((el) => {
        el.classList.toggle('ff-quiz__option--selected', el.dataset.opt === value);
        el.setAttribute('aria-pressed', el.dataset.opt === value ? 'true' : 'false');
      });
      const allAnswered = q.groups.every((g) => state.answers[g.id]);
      nextBtn.hidden = false;
      nextBtn.disabled = !allAnswered;
      nextBtn.textContent = allAnswered ? 'Continue →' : 'Pick both →';
      return;
    }

    if (q.type === 'multi') {
      const arr = Array.isArray(state.answers[q.id]) ? state.answers[q.id].slice() : [];
      const idx = arr.indexOf(value);
      if (idx >= 0) arr.splice(idx, 1); else arr.push(value);
      state.answers[q.id] = arr;
      const selected = arr.includes(value);
      btn.classList.toggle('ff-quiz__option--selected', selected);
      btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
      nextBtn.hidden = false;
      nextBtn.textContent = arr.length === 0 && q.skippable ? 'Skip →' : 'Continue →';
      saveState();
    } else {
      state.answers[q.id] = value;
      saveState();
      // Auto-advance on single-select after a short visual confirmation
      questionEl.querySelectorAll('.ff-quiz__option').forEach((el) => {
        el.classList.toggle('ff-quiz__option--selected', el.dataset.opt === value);
        el.setAttribute('aria-pressed', el.dataset.opt === value ? 'true' : 'false');
      });
      setTimeout(advance, 280);
    }
  }

  function advance() {
    if (state.current >= QUESTIONS.length - 1) {
      // All questions done → email screen
      show('email');
      return;
    }
    state.current += 1;
    saveState();
    renderQuestion();
  }
  function back() {
    if (state.current === 0) return;
    state.current -= 1;
    saveState();
    renderQuestion();
  }

  // ----- Scoring -----
  function score(p, ans) {
    let s = 0;
    const reasons = [];

    // Hard-ish gender filter (only if user picked a specific gender)
    const wantGender = ans.gender;
    if (wantGender && wantGender !== 'any') {
      if (p.g) {
        if (p.g === wantGender) { s += 6; }
        else if (p.g === 'unisex') { s += 3; reasons.push('a unisex pick'); }
        else { s -= 8; }
      } else {
        s += 1; // unknown gender — neutral
      }
    } else {
      s += 1;
    }

    // Vibe → family + intensity
    if (ans.vibe) {
      const map = VIBE_MAP[ans.vibe] || {};
      const famHit = (p.f || []).some((f) => (map.families || []).indexOf(f) >= 0);
      if (famHit) {
        s += 4;
        const matchedFam = (p.f || []).find((f) => (map.families || []).indexOf(f) >= 0);
        reasons.push(`its ${matchedFam.toLowerCase()} character`);
      }
      if (map.intensity && p.it === map.intensity) { s += 2; }
      else if (map.intensity && p.it === 'Balanced') { s += 1; }
    }

    // Loved notes
    const lovedTokens = (ans.love_notes || []).flatMap((g) => NOTE_GROUPS[g] || []);
    const productNotes = ((p.nt || []).concat(p.nh || []).concat(p.nb || []));
    const lovedHits = productNotes.filter((n) => lovedTokens.indexOf(n) >= 0);
    if (lovedHits.length > 0) {
      s += Math.min(8, lovedHits.length * 3);
      // Show distinct hit notes in their canonical capitalised form.
      const distinct = Array.from(new Set(lovedHits)).slice(0, 2);
      reasons.push(`${distinct.join(' & ')} at the heart`);
    }

    // Hated notes — strong de-prioritisation, but not a hard exclude (per spec)
    const hatedTokens = (ans.hate_notes || []).flatMap((g) => NOTE_GROUPS[g] || []);
    const hatedHits = productNotes.filter((n) => hatedTokens.indexOf(n) >= 0);
    if (hatedHits.length > 0) s -= 6 * hatedHits.length;

    // Season
    if (ans.season) {
      if (ans.season === 'All-season') {
        if ((p.s || []).indexOf('All-season') >= 0) s += 1;
      } else if ((p.s || []).indexOf(ans.season) >= 0) {
        s += 2;
      }
    }

    // Heritage filter — strong nudge when user explicitly chose inspired or original
    if (ans.heritage === 'inspired') {
      if ((p.ib || []).length > 0) { s += 6; reasons.push('the designer-inspired DNA'); }
      else { s -= 3; }
    } else if (ans.heritage === 'original') {
      if ((p.ib || []).length === 0) { s += 6; reasons.push('its Flora Five origin'); }
      else { s -= 3; }
    }
    // 'both' — neutral

    // Availability nudge — prefer available products but don't exclude
    if (p.a) s += 0.5;

    return { score: s, reasons: reasons };
  }

  function chooseTop(ans, n) {
    const scored = products
      .map((p) => Object.assign({ p }, score(p, ans)))
      .sort((a, b) => b.score - a.score);
    // De-duplicate near-identical titles to avoid showing 6 versions of the same scent
    const seen = new Set();
    const out = [];
    for (const r of scored) {
      const key = (r.p.t || '').toLowerCase().split(/[—|–|-]/)[0].trim().slice(0, 30);
      if (seen.has(key)) continue;
      seen.add(key);
      out.push(r);
      if (out.length >= n) break;
    }
    return out;
  }

  function buildSummary(ans, picks) {
    const parts = [];
    if (ans.vibe) parts.push(`a ${ans.vibe} signature`);
    if (ans.love_notes && ans.love_notes.length) parts.push(`built around ${ans.love_notes.slice(0, 2).join(' & ').toLowerCase()}`);
    if (ans.season && ans.season !== 'All-season') parts.push(`tuned for ${ans.season.toLowerCase()}`);
    if (parts.length === 0) return `Six attars from across our 250+ fragrances, sorted by best fit.`;
    return `You asked for ${parts.join(', ')}. Here's what we picked.`;
  }

  // Stash the most-recent results so the bundle modal can reuse them.
  let lastPicks = [];
  let lastBundlePool = [];

  function renderResults(ans) {
    // Surface ₹100 cash banner if the user gave their email.
    const cashBanner = root.querySelector('[data-cash-banner]');
    if (cashBanner) cashBanner.hidden = !state.flora100Granted;
    // Hydrate banner from state if we already have a code, or fetch fresh if we have email but no code yet.
    if (state.flora100Granted) {
      if (state.flora100Code) paintCashBanner(state.flora100Code);
      else if (state.email) fetchFlora100Code(state.email);
    }
    const picks = chooseTop(ans, 6);
    // Build a much wider pool — top 40 by quiz score — so the bundle picker always
    // finds 6 with an available variant at the chosen size.
    lastBundlePool = chooseTop(ans, 40);
    lastPicks = picks;
    const grid = root.querySelector('[data-results-grid]');
    const summaryEl = root.querySelector('[data-results-summary]');
    summaryEl.textContent = buildSummary(ans, picks);

    showBundleBannerIfEligible(picks);
    grid.innerHTML = picks.map((entry, idx) => {
      const p = entry.p;
      const reasonText = entry.reasons.length
        ? `Picked for ${entry.reasons.slice(0, 2).join(' and ')}.`
        : `A balanced match across your preferences.`;
      const inspiredLine = (p.ib && p.ib.length)
        ? `<div class="ff-quiz__result-inspired">Inspired by ${escapeHtml(p.ib.slice(0, 2).join(', '))}</div>`
        : '';
      const oosLine = !p.a ? `<span class="ff-quiz__result-oos">Notify me</span>` : '';
      const rankBadge = idx === 0 ? `<div class="ff-quiz__result-rank ff-quiz__result-rank--top">Top match</div>` : `<div class="ff-quiz__result-rank">#${idx + 1}</div>`;
      return `
        <div class="ff-quiz__result-card">
          ${rankBadge}
          <a href="/products/${encodeURIComponent(p.h)}" class="ff-quiz__result-link">
            ${p.i ? `<img src="${p.i}" alt="" loading="lazy" class="ff-quiz__result-image">` : ''}
            <div class="ff-quiz__result-body">
              <h3 class="ff-quiz__result-title">${escapeHtml(displayNameFor(p))}</h3>
              ${inspiredLine}
              <div class="ff-quiz__result-rationale">${escapeHtml(reasonText)}</div>
              <div class="ff-quiz__result-meta">
                <span class="ff-quiz__result-price">₹${p.p}</span>
                ${oosLine}
              </div>
            </div>
          </a>
        </div>`;
    }).join('');
    progressFill.style.width = '100%';
  }

  // ----- Email handling -----
  const FLORA100_API = 'https://flora-five-api.vercel.app/api/issue-flora100';

  function submitEmail(email) {
    const errEl = root.querySelector('[data-email-error]');
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errEl.textContent = 'Please enter a valid email.';
      errEl.hidden = false;
      return false;
    }
    errEl.hidden = true;
    state.flora100Granted = true;
    state.email = email;
    saveState();
    try {
      const profile = { email: email, answers: state.answers, ts: Date.now(), flora100: true };
      localStorage.setItem('ff_quiz_lead', JSON.stringify(profile));
      if (window.dataLayer && Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: 'ff_quiz_lead_captured', email_hash: btoa(email).slice(0, 16), profile: state.answers });
      }
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify({ email: email, ff_quiz_profile: JSON.stringify(state.answers), flora100_eligible: true });
      }
    } catch (_) {}
    // Kick off code-fetch in the background. The banner shows a placeholder until it lands.
    fetchFlora100Code(email);
    return true;
  }

  /**
   * Hit the Vercel endpoint to mint (or retrieve) the unique single-use ₹100 code
   * for this customer. Same email always gets the same code; each code is single-use
   * globally so it can't be shared meaningfully.
   */
  let _flora100Pending = false;
  function fetchFlora100Code(email) {
    if (state.flora100Code) {
      // Already issued in a previous submit — surface from state.
      paintCashBanner(state.flora100Code);
      return;
    }
    // Dedupe in-flight fetches: submitEmail() and renderResults() can both call
    // this within ~1.5s during the loading screen race; without this guard the
    // server records two quiz_responses rows for one submission.
    if (_flora100Pending) return;
    _flora100Pending = true;
    // Compute the same top-6 the results screen will show, so the response row
    // in Supabase pairs the email with what we recommended.
    let topPicks = null;
    try {
      topPicks = chooseTop(state.answers, 6).map((entry) => ({
        handle: entry.p.h || null,
        title:  entry.p.t || null,
        gid:    entry.p.gid || null,
        score:  Math.round(entry.score * 10) / 10
      }));
    } catch (_) {}

    fetch(FLORA100_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email,
        answers: state.answers || {},
        top_picks: topPicks
      })
    })
      .then((r) => r.ok ? r.json() : Promise.reject(r.status))
      .then((data) => {
        if (data && data.code) {
          state.flora100Code = data.code;
          saveState();
          paintCashBanner(data.code);
        } else {
          paintCashBannerError();
        }
      })
      .catch(() => paintCashBannerError())
      .finally(() => { _flora100Pending = false; });
  }

  function paintCashBanner(code) {
    const codeEl = root.querySelector('[data-cash-code]');
    const copyBtn = root.querySelector('[data-action="copy-cash-code"]');
    const applyEl = root.querySelector('[data-cash-apply]');
    const statusEl = root.querySelector('[data-cash-status]');
    if (codeEl) codeEl.textContent = code;
    if (statusEl) statusEl.innerHTML = 'Use code <strong data-cash-code>' + escapeHtml(code) + '</strong> at checkout. Min order ₹500. Single use, just for you.';
    if (copyBtn) copyBtn.disabled = false;
    if (applyEl) {
      applyEl.setAttribute('href', '/discount/' + encodeURIComponent(code) + '?redirect=/cart');
      applyEl.removeAttribute('aria-disabled');
    }
  }

  function paintCashBannerError() {
    const statusEl = root.querySelector('[data-cash-status]');
    if (statusEl) statusEl.textContent = 'We couldn’t generate your code right now. Refresh the page or contact support — your reward is saved against your email.';
  }

  // ----- Bundle offer (Get all 6 for the price of 4) -----
  const BUNDLE_DISCOUNT_CODE = 'QUIZBUNDLE6';
  const BUNDLE_SIZES = [
    { key: '3',  label: '3 ml',  blurb: 'Perfect for trial / travel' },
    { key: '6',  label: '6 ml',  blurb: 'Everyday wear · most popular' },
    { key: '12', label: '12 ml', blurb: 'Best value · longest pour' }
  ];

  function showBundleBannerIfEligible(picks) {
    const banner = root.querySelector('[data-bundle-banner]');
    if (!banner) return;
    // Show only if at least 6 picks have at least one variant available.
    const eligible = picks.filter((entry) => entry.p && entry.p.v && (entry.p.v['3'] || entry.p.v['6'] || entry.p.v['12']));
    banner.hidden = eligible.length < 6;
  }

  function pickBundleVariants(sizeKey) {
    // Walk the wider pool; collect 6 products with an available variant at the chosen size.
    const out = [];
    const seen = new Set();
    const tryAdd = (p) => {
      if (!p || !p.v) return false;
      if (seen.has(p.id)) return false;
      const variantId = p.v[sizeKey];
      const available = p.va && p.va[sizeKey];
      if (!variantId || !available) return false;
      seen.add(p.id);
      out.push({
        id: variantId,
        product_id: p.id,
        handle: p.h,
        name: displayNameFor(p),
        price: p.vp ? parseFloat(p.vp[sizeKey] || '0') : parseFloat(p.p)
      });
      return true;
    };

    // First pass: walk the quiz-scored pool.
    for (const entry of lastBundlePool) {
      tryAdd(entry.p);
      if (out.length >= 6) return out;
    }

    // Fallback: if scored pool didn't yield 6 in-stock at this size, score the full
    // catalogue and append the highest-ranking still-available products. This guarantees
    // a complete bundle even when most quiz-matches happen to be OOS at the chosen size.
    if (out.length < 6) {
      const ans = state.answers || {};
      const wider = products
        .filter((p) => !seen.has(p.id) && p.v && p.v[sizeKey] && p.va && p.va[sizeKey])
        .map((p) => Object.assign({ p }, score(p, ans)))
        .sort((a, b) => b.score - a.score);
      for (const entry of wider) {
        tryAdd(entry.p);
        if (out.length >= 6) break;
      }
    }
    return out;
  }

  function renderSizeCards() {
    const grid = root.querySelector('[data-size-grid]');
    if (!grid) return;
    grid.innerHTML = BUNDLE_SIZES.map((size) => {
      const items = pickBundleVariants(size.key);
      const enough = items.length >= 6;
      // Total = sum of 6 unit prices; payable = sum of 4 most expensive.
      const sortedDesc = items.slice().sort((a, b) => b.price - a.price);
      const total = sortedDesc.reduce((s, it) => s + it.price, 0);
      const payable = sortedDesc.slice(0, 4).reduce((s, it) => s + it.price, 0);
      const save = total - payable;
      const inrTotal = Math.round(total).toLocaleString('en-IN');
      const inrPay = Math.round(payable).toLocaleString('en-IN');
      const inrSave = Math.round(save).toLocaleString('en-IN');
      const disabled = !enough ? 'disabled' : '';
      const detail = enough ? `${size.blurb} · 6 attars × ${size.label}` : `Only ${items.length} of 6 in stock at ${size.label}`;
      return `
        <button type="button" class="ff-quiz__size-card" data-size="${size.key}" ${disabled}>
          <span class="ff-quiz__size-card-left">
            <span class="ff-quiz__size-card-volume">${size.label} each</span>
            <span class="ff-quiz__size-card-detail">${escapeHtml(detail)}</span>
          </span>
          <span class="ff-quiz__size-card-right">
            ${enough ? `<span class="ff-quiz__size-card-was">₹${inrTotal}</span>` : ''}
            ${enough ? `<span class="ff-quiz__size-card-now">₹${inrPay}</span>` : ''}
            ${enough ? `<span class="ff-quiz__size-card-save">Save ₹${inrSave}</span>` : ''}
          </span>
        </button>`;
    }).join('');

    grid.querySelectorAll('.ff-quiz__size-card[data-size]:not([disabled])').forEach((btn) => {
      btn.addEventListener('click', () => onSizeChosen(btn.dataset.size, btn));
    });
  }

  function openBundleModal() {
    renderSizeCards();
    const modal = root.querySelector('[data-modal="bundle"]');
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    // Pre-warm: clear the cart in the background while the user picks a size,
    // so the eventual permalink starts from an empty cart instantly. Saves ~300ms.
    try {
      fetch('/cart/clear.js', { method: 'POST', keepalive: true }).catch(() => {});
    } catch (_) {}
    // Pre-warm: kick a TCP/TLS connection to /cart so the permalink request reuses it.
    try {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = window.location.origin;
      document.head.appendChild(link);
    } catch (_) {}
  }

  function closeBundleModal() {
    const modal = root.querySelector('[data-modal="bundle"]');
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  function onSizeChosen(sizeKey, btn) {
    const items = pickBundleVariants(sizeKey);
    if (items.length < 6) return;
    // Lock the button, show inline spinner.
    btn.disabled = true;
    const right = btn.querySelector('.ff-quiz__size-card-right');
    if (right) right.innerHTML = '<span class="ff-quiz__size-card-loading"></span>';

    // Telemetry first (synchronous, instant).
    try {
      if (window.dataLayer) {
        window.dataLayer.push({ event: 'ff_quiz_bundle_add', size: sizeKey, items: items.map((i) => i.product_id) });
      }
    } catch (_) {}

    // Build a single Shopify cart permalink that:
    //   1. Adds all 6 variants in one request,
    //   2. Applies the QUIZBUNDLE6 discount via the discount param,
    //   3. Returns to /checkout — Shopify renders the items+discount, skips the cart page.
    // This replaces the prior 4-roundtrip flow (clear → add → /discount → /checkout)
    // with a single navigation. Cart was pre-cleared on modal open.
    const variantList = items.map((it) => `${it.id}:1`).join(',');
    const url = `/cart/${variantList}`
      + `?discount=${encodeURIComponent(BUNDLE_DISCOUNT_CODE)}`
      + `&return_to=${encodeURIComponent('/checkout')}`;

    window.location.href = url;
  }

  // ----- Wire up actions -----
  root.querySelector('[data-action="start"]').addEventListener('click', () => {
    state.current = 0; state.answers = {};
    saveState();
    show('questions');
  });
  backBtn.addEventListener('click', back);
  nextBtn.addEventListener('click', advance);
  root.querySelector('[data-action="skip-email"]').addEventListener('click', () => {
    show('loading');
    setTimeout(() => { renderResults(state.answers); show('results'); }, 600);
  });
  root.querySelector('[data-email-form]').addEventListener('submit', (e) => {
    e.preventDefault();
    const email = root.querySelector('[data-email-input]').value.trim();
    if (!submitEmail(email)) return;
    show('loading');
    setTimeout(() => { renderResults(state.answers); show('results'); }, 700);
  });
  root.querySelector('[data-action="retake"]').addEventListener('click', () => {
    clearState();
    state.current = 0; state.answers = {};
    show('intro');
  });
  // Copy ₹100 code to clipboard
  const copyCashBtn = root.querySelector('[data-action="copy-cash-code"]');
  if (copyCashBtn) {
    copyCashBtn.addEventListener('click', () => {
      const code = state.flora100Code || root.querySelector('[data-cash-code]')?.textContent?.trim();
      if (!code || code === '—') return;
      const setLabel = (txt) => { const el = root.querySelector('[data-action="copy-cash-code"]'); if (el) el.textContent = txt; };
      const restore = () => setTimeout(() => setLabel('Copy code'), 2000);
      try {
        if (navigator.clipboard) {
          navigator.clipboard.writeText(code).then(() => { setLabel('Copied ✓'); restore(); });
        } else {
          const tmp = document.createElement('textarea');
          tmp.value = code; document.body.appendChild(tmp); tmp.select();
          document.execCommand('copy'); document.body.removeChild(tmp);
          setLabel('Copied ✓'); restore();
        }
      } catch (_) {}
    });
  }
  root.querySelector('[data-action="open-bundle"]').addEventListener('click', openBundleModal);
  root.querySelectorAll('[data-action="close-bundle"]').forEach((el) => el.addEventListener('click', closeBundleModal));
  document.addEventListener('keyup', (e) => {
    if (e.key === 'Escape') {
      const modal = root.querySelector('[data-modal="bundle"]');
      if (modal && !modal.hidden) closeBundleModal();
    }
  });
  root.querySelector('[data-action="share"]').addEventListener('click', () => {
    const url = window.location.origin + window.location.pathname + '#scent';
    if (navigator.share) {
      navigator.share({ title: 'My Flora Five scent profile', url: url }).catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(() => {
        const btn = root.querySelector('[data-action="share"]');
        const oldLabel = btn.textContent;
        btn.textContent = 'Link copied ✓';
        setTimeout(() => { btn.textContent = oldLabel; }, 2000);
      });
    }
  });

  // ----- Helpers -----
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    })[c]);
  }

  // Clean a long marketing title down to the recognisable product name.
  // Preferred path: use the curated `dn` (custom.display_name) metafield.
  // Fallback: strip known SEO/marketing suffixes from the title.
  function displayNameFor(p) {
    if (p.dn && p.dn.trim()) return p.dn.trim();
    let t = String(p.t || '').trim();
    // Drop trailing " | Flora Five" / " by Flora Five" / " – Flora Five" / similar.
    t = t.replace(/\s*[—–|-]\s*Flora Five\s*$/i, '');
    t = t.replace(/\s*by Flora Five\s*$/i, '');
    // Drop common SEO suffix patterns after an em-dash or pipe.
    t = t.replace(/\s*[—–]\s*Alcohol[- ]Free Perfume Oil.*$/i, '');
    t = t.replace(/\s*\|\s*Alcohol[- ]Free.*$/i, '');
    t = t.replace(/\s*\|\s*[A-Z][^|]*Perfume Oil.*$/i, '');
    t = t.replace(/\s*\(Alcohol[- ]Free\)\s*$/i, '');
    t = t.replace(/\s*[—–-]\s*[A-Z][^—–\-]*\bOil Perfume[^—–\-]*$/i, '');
    // Strip "Inspired Attar" filler when followed by descriptors
    t = t.replace(/\s+Inspired Attar\s*[—–|-]?.*$/i, ' Inspired');
    // Strip trailing " Attar" if it's the only remaining piece (let bare designer name stand)
    // — only when the title still looks long-form descriptor (more than 4 words).
    return t.trim();
  }

  // ----- Initial screen -----
  // Restore where the user left off. Memory persists 30 days so they can refresh,
  // close the tab, and come back to the same shortlist + answers without re-doing the quiz.
  function restoreScreen() {
    const ans = state.answers || {};
    const answeredCount = Object.keys(ans).filter((k) => {
      const v = ans[k];
      return v !== undefined && v !== '' && !(Array.isArray(v) && v.length === 0);
    }).length;
    const lastScreen = state.screen;

    if (lastScreen === 'results' || lastScreen === 'loading') {
      if (answeredCount >= 5 && products.length > 0) {
        renderResults(ans);
        show('results');
        return;
      }
    }
    if (lastScreen === 'email' && answeredCount >= 5) {
      show('email');
      return;
    }
    if (lastScreen === 'questions' && typeof state.current === 'number' && state.current < QUESTIONS.length) {
      show('questions');
      return;
    }
    show('intro');
  }
  restoreScreen();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("or-timeline__img--bounce-in"),t.contents[e].classList.add("or-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-or-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();
})();
